import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../../Containers/Config/index.js';
import { LIST_SERVICE_WORTH, LIST_SERVICE_WORTH_SUCCESS, LIST_SERVICE_WORTH_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* getServiceWorthList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/service-worth`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: LIST_SERVICE_WORTH_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: LIST_SERVICE_WORTH_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: LIST_SERVICE_WORTH_ERROR, payload: error });
  }
}

export function* watchServiceWorthList() {
  yield takeEvery(LIST_SERVICE_WORTH, getServiceWorthList);
}

function* serviceWorthListSaga() {
  yield all([fork(watchServiceWorthList)]);
}

export default serviceWorthListSaga;
